module.exports = __webpack_public_path__ + "img/invoice-serial-number.37bf6620.svg";